import { render } from "./JournalMetaData.vue?vue&type=template&id=2971ff1a"
import script from "./JournalMetaData.vue?vue&type=script&lang=js"
export * from "./JournalMetaData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__